<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            editData() {return this.$store.getters.PAG_PROVIDER_EDIT}
        },
        methods: {
            async changeData(event, fieldName, isCheckBox = false) {

                const data = isCheckBox === true ? 
                    event.target.checked :
                    event.target.value;
                this.$store.commit('PAG_PROVIDER_EDIT_UPDATE', {
                    fieldName: fieldName, 
                    fieldValue: data,
                });
                this.errorText = await this.$store.dispatch('CHECK_PROVIDER_EDIT');
            },
            async clearSortIndex(event) {
                if (event.target.checked === false) {
                    this.$store.commit('PAG_PROVIDER_EDIT_UPDATE', {
                        fieldName: 'sort_index', 
                        fieldValue: null,
                    });
                }
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            @change="changeData($event, 'name')"
            :value="editData['name']"
            class="right_input mt_5 mb_10" 
            type="text"
        >
        <label>
            <input 
                @change="changeData($event, 'is_premium', true)"
                :checked="editData['is_premium']"
                type="checkbox"
            >
            Premium
        </label>
        <label
            class="mb_10"
        >
            <input 
                @change="
                    changeData($event, 'is_default', true);
                    clearSortIndex($event);
                "
                :checked="editData['is_default']"
                type="checkbox"
            >
            Default
        </label>
        <label>Sort Index:</label>
        <input
            :disabled="editData['is_default'] === false"
            @change="changeData($event, 'sort_index')"
            :value="editData['sort_index']"
            class="right_input mt_5" 
            type="number"
        >
        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>